module.exports = __webpack_public_path__ + "img/116.7e1c1811.jpg";